import { Component, Prop, h } from "@stencil/core";
import { WarningNotification } from "@apis/responses/add-to-cart-response";

@Component({
  tag: "bcp-add-to-cart-error-container",
  styleUrl: "bcp-add-to-cart-error-container.scss",
})
export class BcpAddToCartErrorContainer {
  @Prop({ mutable: true }) warnings: WarningNotification[];

  render() {
    return (
      <div class="cart-warning-message">
        {this.warnings
          ? this.warnings.map((warn) => <span>{warn.text}</span>)
          : ""}
      </div>
    );
  }
}
